import { render, staticRenderFns } from "./downloadButton.vue?vue&type=template&id=356bf4f8&"
import script from "./downloadButton.vue?vue&type=script&lang=js&"
export * from "./downloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports